import axios from 'axios'
import dayjs from 'dayjs'
import pkce from '../../helpers/pkce'
import qs from 'qs'
import jwtDecode from 'jwt-decode'
import httpClient from '../../services/httpClient'

const state = {
  token: '',
  refreshToken: '',
  sessionTimeout: '',
  promptSessionAlert: false,
  tokens: ''
}

const actions = {
  login: async ({}) => {

    await sessionStorage.removeItem('verifier')
    await sessionStorage.removeItem('token')

    const code_verifier = await pkce.generateRandomString()
    const code_challenge = await pkce.pkceChallengeFromVerifier(code_verifier)

    sessionStorage.setItem('verifier', code_verifier)

    let queries = qs.stringify({
      client_id: process.env.VUE_APP_AKAMAI_OIDC_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_AKAMAI_REDIRECT_URI,
      scope: 'openid email',
      code_challenge: code_challenge,
      code_challenge_method: 'S256',
      response_type: 'code',
      claims: `{
        "userinfo": {
          "sub": null,
          "iss": null,
          "auth_time": null,
          "email": null,
          "agent_customer_id": null,
          "agent_uuid": null,
          "displayName": null
        },
        "id_token": {
          "sub": null,
          "iss": null,
          "auth_time": null,
          "email": null,
          "agent_customer_id": null,
          "agent_uuid": null,
          "displayName": null
        }
      }`,
      prompt: 'login',
      display: 'popup'
    })

    let uri = `https://v1.api.sg.janrain.com/ce59fa68-5131-44fc-9d97-a8d9137728b1/login/authorize?${queries}`

    const w = 500
    const h = 700

    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(uri, '',
      `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
    )

    if (window.focus) newWindow.focus();
  },

  logout: ({ commit }) => {

    // return console.warn('user logged out')

    sessionStorage.removeItem('token')
    sessionStorage.removeItem('verifier')

    commit('logout_success')

    let queries = qs.stringify({
      client_id: process.env.VUE_APP_AKAMAI_OIDC_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_AKAMAI_REDIRECT_URI
    })

    let uri = `https://v1.api.sg.janrain.com/ce59fa68-5131-44fc-9d97-a8d9137728b1//auth-ui/logout?${queries}`

    window.location.replace(uri)
  },

  probeSessioMonitoring: ({ state, dispatch, getters }, prober) => {
    let secondsToTimeout = dayjs().diff(state.sessionTimeout, 'second')

    if (!getters.isAuthenticated || secondsToTimeout > 0) {
      return dispatch('logout')
    }

    if (!state.sessionExpirePrompt && Math.abs(secondsToTimeout) < 300 && prober === 'timer') {
      return false
    }

    return true
  },

  getToken: async ({ commit, dispatch }, auth_code) => {

    let code_verifier = await sessionStorage.getItem('verifier')

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: 'https://v1.api.sg.janrain.com/ce59fa68-5131-44fc-9d97-a8d9137728b1/login/token',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          grant_type: 'authorization_code',
          client_id: process.env.VUE_APP_AKAMAI_OIDC_CLIENT_ID,
          redirect_uri: process.env.VUE_APP_AKAMAI_REDIRECT_URI,
          code: auth_code,
          code_verifier: code_verifier
        })
      })
      .then(async resp => {

        const { id_token, refresh_token } = resp.data
        sessionStorage.setItem('token', id_token)
        commit('set_refresh_token', refresh_token)
        resolve(id_token)

      })
      .catch(err => reject(err))
    })
  },

  initiateSession: async ({ commit, dispatch, rootState }, payload) => {

    const { token } = payload
    const { sub, email, exp, agent_customer_id } = jwtDecode(token)

    // Inject login JWT token to httpClient instance header
    httpClient.defaults.headers.common.Authorization = `Bearer ${token}`

    commit('login_success', token)
    // commit('set_session_timeout', dayjs().add(parseInt(20), 'seconds')) // use this to bypass expiry
    commit('set_session_timeout', dayjs.unix(exp)) // take session expire from token expiry tinestamp
    commit('user/set_uuid', sub, { root: true })
    commit('user/set_email', email, { root: true })
    
    await dispatch('populateAgentInfo', agent_customer_id)
    await dispatch('generateTeamieToken', rootState.user.nric.replace(/-/g, ""))
    .then((td) => {
      commit('user/set_teamieData', td.data, { root: true })
    })
    
  },

  fetchAgentMapping: async ({ state }, identity) => {
    return httpClient({
      url: process.env.VUE_APP_APIURL + '/iaccess/v3/user/mapping',
      method: 'GET',
      params: {
        identification_id: identity,
        user_type: 'Agent'
      }
    })
  },

  fetchAgentInfo: async ({ state }, agentCustomerId) => {
    return httpClient({
      url: process.env.VUE_APP_APIURL + '/agent/v2/agents',
      method: 'GET',
      params: {
        agentcustomerid: agentCustomerId
      }
    })
  },

  fetchHOFInfo: async ({ state }) => {
    return httpClient({
      url: process.env.VUE_APP_APIURL + '/pbmicrosite/halloffame/list',
      method: 'GET',
    })
  },

  generateTeamieToken: async ({ state, commit }, payload) => {
    let user_ic = payload

    return await axios.get(process.env.VUE_APP_CMS_URL + '/api/teamie/token?ic=' + user_ic)
  },

  populateAgentInfo: async ({dispatch, commit }, identity) => {

    // return Promise.reject('no_agent_mapping') // Uncomment this to force re-mapping

    if (!identity) return Promise.reject('no_agent_mapping')

    let requests = [
      dispatch('fetchAgentMapping', identity),
      dispatch('fetchAgentInfo', identity),
      dispatch('fetchHOFInfo'),
    ]

    return Promise.all(requests)
      .then(responses => {
        let agentMappingStatus = responses[0].data
        let agentInfo = responses[1].data.filter(v => v.Status === 'A')[0]
        let HOFInfo = responses[2].data.personalAum
        
        // Agent Active
        let personalAumCurrentAgent = HOFInfo.filter((item) => (item.nricNew == (agentInfo.NewNRIC.replace(/-/g, ""))))
        var agentProfilePicture = require('@/assets/img/male-defPic.png')

        // Agent Profile Picture
        if(personalAumCurrentAgent.length > 0) {
          if (personalAumCurrentAgent[0].imageUrl) {
            agentProfilePicture =  personalAumCurrentAgent[0].imageUrl
          }
          else {
            if (personalAumCurrentAgent[0].gender == 'Male') {
              agentProfilePicture = require('@/assets/img/male-defPic.png')
            }
            else {
              agentProfilePicture = require('@/assets/img/female-defPic.png')
            }
          }
        }
        
        if (agentInfo.ChannelCode !== 'PB') {
          return Promise.reject('not_pb_agent')
        }

        if (!agentMappingStatus.mapping_details[0].is_agent_active) {
          return Promise.reject('agent_inactive')
        }

        if (!agentMappingStatus.mapping_details[0].is_mapped) {
          return Promise.reject('no_agent_mapping')
        }

        commit('user/set_name', agentInfo.Name, { root: true })
        commit('user/set_nric', agentInfo.NewNRIC, { root: true })
        commit('user/set_phoneNo', agentInfo.PhoneNumber, { root: true })
        commit('user/set_ranking', agentInfo.AgentRanking, { root: true })
        commit('user/set_picture', agentProfilePicture, { root: true })

        return Promise.resolve()
      })
      
      .catch(err => Promise.reject(err))
  },

  
}

const mutations = {
  login_success(state, token) {
    state.token = token
  },

  logout_success(state) {
    state.token = ''
    state.sessionTimeout = ''
  },

  set_session_timeout(state, timeout) {
    state.sessionTimeout = timeout
  },

  update_session_state(state, sessionState) {
    state.isSessionValid = sessionState
  },

  set_refresh_token(state, token) {
    state.refreshToken = token
  },

  update_has_prompt_alert(state, payload) {
    state.promptSessionAlert = payload
  },

  set_tokens(state, payload) {
    let tokens = payload.reduce((i, v) => {
      i[v.api_name] = v.access_token
      return i
    }, {})

    state.tokens = tokens
  }
}

const getters = {
  isAuthenticated: (state) => !!state.token
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
